export default __webpack_public_path__ + "static/media/fi-rr-angle-small-up.287dde69.svg";